const achievements = [
    {
      title: 'First bug bounty 😮',
      description: 'Bug type: Reflected XSS & Html injection',
      screenshot: '1.png',
    },
    {
      title: 'First HOF [Hall of Fame] ⚡',
      description: 'Ethically Hacked and reported the vulnerability to www.inflectra.com 🧑🏻‍💻',
      screenshot: '2.png',
    },
    {
      title: 'ACKNOWLEDGED BY NASA 🚀',
      description: 'VULNERABILITY: Information Exposure Through Directory Listing ',
      screenshot: '3.png',
    },
    {
      title: 'ACKNOWLEDGED BY Stayfriends.de',
      description: 'Ethically Hacked and reported the vulnerability 🧑🏻‍💻',
      screenshot: '4.png',
    },
    {
      title: 'APPRECIATION BY klifs.net',
      description: 'Bug type: Exposure of information through directory listing. 🧑🏻‍💻',
      screenshot: '5.png',
    },
    {
      title: 'APPRECIATION BY bayareaveg.org 💥',
      description: 'Bug type: Reflected XSS 🧑🏻‍💻',
      screenshot: '6.png',
    },
    {
      title: 'APPRECIATION BY telekom.com !!',
      description: 'Bug type: Origin IP found, WAF Cloudflare Bypass 🧑🏻‍💻',
      screenshot: '7.png',
    },
    {
      title: 'APPRECIATION BY yourdost.com',
      description: 'Vulnerability: HTML INJECTION ATTACK 🧑🏻‍💻',
      screenshot: '8.png',
    },
    {
      title: 'Acknowledged BY shadi.com [DUPLICATE] 🥲',
      description: 'Vulnerability: HTML INJECTION ATTACK 🧑🏻‍💻',
      screenshot: '9.png',
    },
    {
      title: 'Acknowledged BY drexel.edu [DUPLICATE] 🥲',
      description: 'Vulnerability: Clickjacking 🧑🏻‍💻',
      screenshot: '10.png',
    },
    // Add more achievements as needed
  ];
  
  export default achievements;
  